module.exports = __webpack_public_path__ + "img/_85C9122.050c3275.jpeg";